import React from 'react';
import classnames from 'classnames';
import { A } from './ServiceBadge.styles';

type ServiceBadgeProps = {
  size?: 'small' | 'medium';
  name: string;
  url: string;
};

export default function ServiceBadge({ size = 'small', name, url }: ServiceBadgeProps) {
  const classNames = classnames('ellipsis', size);
  return (
    <A href={url} className={classNames} target="_blank" title={name ?? ''}>
      {name}
    </A>
  );
}
